export const LeaveSettingVI = {
    "leave-setting": {
        "headingLabel": "Cài đặt nghỉ phép",
        "createNew": "Tạo mới cài đặt nghỉ phép",
        "generalSetting": "Cài đặt chung",
        "senioritySetting": "Cài đặt phép thâm niên",
        "otherSetting": "Cài đặt khác",
        "leaveSettingName": "Tên cài đặt nghỉ phép",
        "positionApllication": "Đối tượng áp dụng",
        "numberOfLeaveDay": "Số ngày phép",
        "leaveSettingNameDetails": "Tên cài đặt nghỉ phép sẽ áp dụng cho cả cài đặt phép thâm niên và cài đặt khác",
        "timeApplication": "Thời gian áp dụng",
        "timeApplicationDetails1": "Các cài đặt bên dưới sẽ chỉ được áp dụng trong thời gian này.",
        "timeApplicationDetails2": "Khi có sự thay đổi quy định hưởng phép, bạn thêm mới cài đặt khác và chọn lại thời gian áp dụng.",
        "timeApplicationDetails3": "Nếu tháng kết thúc để trống, phép của tháng hiện tại sẽ tính toán theo cài đặt này.",
        "fromMonth": "Từ tháng",
        "toMonth": "Đến tháng",
        "applicableObject": "Đối tượng áp dụng",
        "conditionsApply": "Điều kiện áp dụng",
        "advanceLeave": "Số phép ứng",
        "dayWorkOnLeave": "Số ngày đi làm trong tháng để được tính phép",
        "generalInformation": "Thông tin chung",
        "dayEndCumulative": "Ngày kết thúc phép lũy kế của năm trước",
        "monthEndCumulative": "Tháng kết thúc phép lũy kế của năm trước",
        "departmentApplication": "Phòng ban áp dụng",
        "departmentApplicationDetails1": "Quy định phép sẽ áp dụng cho toàn bộ phòng ban (trong trường hợp này thì bỏ trống).",
        "departmentApplicationDetails2": "Tuy nhiên mỗi doanh nghiệp sẽ có các quy định khác nhau (Chọn được nhiều phòng ban)",
        "chooseDepartment": "Chọn phòng ban áp dụng",
        "positionApplication": "Vị trí áp dụng",
        "positionApplicationDetails1": "Quy định phép sẽ áp dụng cho toàn bộ vị trí (trong trường hợp này thì bỏ trống).",
        "positionApplicationDetails2": "Tuy nhiên mỗi doanh nghiệp sẽ có các quy định khác nhau (Chọn được nhiều vị trí)",
        "choosePosition": "Chọn vị trí áp dụng",
        "chooseContractType": "Chọn loại hợp đồng áp dụng",
        "choosedayStartContractType": "Là ngày băt đầu của hợp đồng được tính phép",
        "contractType": "Loại hợp đồng được tính phép",
        "contractTypeDetails1": "Theo quy định, tất cả hợp đồng lao động đều được tính phép.",
        "contractTypeDetails2": "Tuy nhiên bạn hoàn toàn có thể thay đổi theo nhu cầu thực tế của công ty.",
        "monthDid": "Số tháng thực hiện hợp đồng để được tính phép",
        "monthDidDetails": "Ví dụ: 1 nhân sự ký hợp đồng lao động 1 năm, nhưng phải làm 2 tháng trở lên mới được tính phép.",
        "dateStartCounted": "Ngày được bắt đầu tính phép",
        "dateStartCountedDetails1": "Nhiều công ty sẽ tính phép cho nhân sự cả hợp đồng thử việc với điều kiện nhân sự đó được ký hợp đồng chính thức.",
        "dateStartCountedDetails2": "Đây là công đoạn để giải quyết bài toán này",
        "maximumLeavePerYear": "Số phép tối đa cho 1 năm",
        "maximumLeavePerYearDetails1": "Theo luật những công việc hành chính là 12 ngày/năm.",
        "maximumLeavePerYearDetails2": "Tuy nhiên đối với những công việc nặng nhọc có thể lên tới 14, 15 ngày.",
        "leavePerMonth": "Phương thức phân bổ phép năm",
        "totalLeaveDivide12": "Lấy tổng số phép tối đa 1 năm chia điều cho 12 tháng",
        "totalLeaveDivide12Details": "Ví dụ: Số phép trong 1 năm của nhân sự là 15 ngày, khi cài đặt lấy số phép tối đa chia đều cho 12 thì mỗi tháng nhân sự được nghỉ 1.25 ngày phép.",
        "1LeavePerMonth": "Mỗi tháng 1 phép, còn lại thì cộng vào tháng đầu",
        "1LeavePerMonthDetails": "Nếu chọn mỗi tháng 1 phép, còn lại thì cộng vào tháng đầu thì tháng đầu nhân sự sẽ được hưởng 4 phép, mỗi tháng sau được hưởng 1 phép.",
        "cycleCountLeave": "Chu kỳ tính phép",
        "cycleCountLeaveDetails1": "Thường các doanh nghiệp có chu kỳ tính phép theo năm dương lịch.",
        "cycleCountLeaveDetails2": "Tuy nhiên có 1 số trường hợp như khối trường học, sản xuất có chu kỳ tính phép không theo năm dương lịch.",
        "toEndMonth": "Đến hết tháng",
        "dayAddNewLeaveOfMonth": "Ngày được thêm phép mới của tháng",
        "dayAddNewLeaveOfMonthDetails1": "Có những doanh nghiệp đầu tháng đã tính phép cho nhân viên, có những doanh nghiệp giữa tháng.",
        "dayAddNewLeaveOfMonthDetails2": "Bạn hãy lựa chọn cho phù hợp với doanh nghiệp mình",
        "firstContractAllowed": "Hợp đồng đầu tiên được tính phép",
        "firstContractAllowedDetails1": "Ví dụ: Nhân sự Nguyễn Văn A, có hợp đồng đầu tiên được tính phép có ngày bắt đầu là 14/03/2016.",
        "firstContractAllowedDetails2": "Nếu cài đặt là ngày 16, thì nhân sự được tính phép tháng đó.",
        "firstContractAllowedDetails3": "Ngược lại nếu cài đặt là ngày 13, thì nhân sự không được tính phép tháng đó.",
        "accumulationEndTime": "Thời gian kết thúc lũy kế (reset phép lũy kế về 0)",
        "accumulationEndTimeDetails1": "Ví dụ: Cài đặt là tháng 3, thì phép lũy kế, thâm niên của năm trước đến hết tháng 3 năm nay thì sẽ được reset về 0.",
        "accumulationEndTimeDetails2": "Có thể chọn tuỳ chỉnh ngày để chọn ngày cụ thể.",
        "accumulationEndTimeDetails3": "Không chọn nghĩa là phép sẽ không được luỹ kế.",
        "employeeLeaveNotAllowed": "Nhân sự nghỉ việc trước ngày này trong tháng thì không được phép tháng đó",
        "employeeLeaveNotAllowedDetails": "Ví dụ: Nếu ngày cài đặt là 15 và bạn nghỉ vào ngày 14 tháng hiện tại thì bạn sẽ không được phép trong tháng hiện tại này.",
        "employeeUnpaidNotAllowed": "Nhân sự nghỉ không lương quá số ngày này trong tháng thì không được hưởng phép của tháng",
        "employeeUnpaidNotAllowedDetails1": "Ví dụ: Nếu ngày cài đặt là 5 ngày và bạn nghỉ không lương trong tháng đó quá từ 5 ngày thì sẽ ko có phép tháng đó.",
        "employeeUnpaidNotAllowedDetails2": "Số ngày nghỉ không lương được tính từ đơn xin nghỉ, với lý do không tính công",
        "allowedSeniority": "Cho phép hưởng phép thâm niên",
        "allowedSeniorityDetails": "Cài đặt cho phép nhân viên làm lâu năm được hưởng thêm phép thâm niên",
        "dayStartCountedSeniority": "Ngày bắt đầu tính phép thâm niên",
        "allowedLeave": "Cho phép ứng phép",
        "allowedLeaveDetails1": "Trong 1 năm, nhân viên chỉ được phép sử dụng số phép trong năm.",
        "allowedLeaveDetails2": "Cài đặt này cho phép nhân viên có thể nghỉ nhiều hơn số phép năm của mình",
        "allowContractType": "Loại hợp đồng được phép ứng",
        "allowContractTypeDetails1": "Ứng phép là 1 tính năng cho phép doanh nghiệp có thể nghỉ nhiều hơn số phép mình đang có.",
        "allowContractTypeDetails2": "Tuy nhiên đều này không đúng với tất cả hợp đồng (trường hợp không chọn là tất cả).",
        "allowContractTypeDetails3": "Hãy chọn loại hợp đồng mà doạnh nghiệp bạn cho phép ứng phép",
        "maximumLeaveApplied": "Số phép tối đa được ứng",
        "maximumLeaveAppliedDetails": "Hãy lựa chọn số phép tối đa nhân viên có thể ứng",
        "monthSeniorytiApllied": "Số tháng thâm niên được quyền ứng phép",
        "monthSeniorytiAplliedDetails1": "Có những nhân viên ký hợp đồng lao động 1 năm và hợp đồng đó được quyền ứng phép.",
        "monthSeniorytiAplliedDetails2": "Tuy nhiên công ty có thể quy định nhân viên phải làm từ tháng thứ 3 mới được tính phép, công đoạn này giúp bạn giải quyết bài toán đó",
        "maternityLeaveNoCounted": "Cài đặt trường hợp nghỉ thai sản không được tính phép",
        "materinityCountedAfter": "Ngày mà người lao động nghỉ thai sản sau ngày này thì sẽ được tính phép của tháng đó",
        "materinityCountedBefore": "Ngày mà người lao động nghỉ thai sản quay trở lại trước ngày này thì sẽ được tính phép của tháng đó",
        "dayStartWork": "Ngày băt đầu làm việc",
        "dayFirstContract": "Ngày ký hợp đồng đầu tiên",
        "daySignedContract": "Ngày ký hợp đồng được tính phép",
        "update": "Cập nhật cài đặt nghỉ phép",
        "status": "Trạng thái",
        "allLeaveFirstMonth": "Cấp toàn bộ phép vào tháng đầu",
        "allLeaveFirstMonthDetails": "Ví dụ: số phép trong 1 năm của nhân sự là 15 ngày, thì tháng đầu tiên của chu kỳ là 15 ngày.",
        "reasonLeave": "Lý do xin nghỉ áp dụng",
        "reasonLeaveDetails1": "Quy định phép sẽ áp dụng cho lý do nghỉ mặc định có ký hiệu PN (trong trường hợp này thì bỏ trống).",
        "reasonLeaveDetails2": "Tuy nhiên mỗi doanh nghiệp sẽ có các quy định khác nhau (Chọn được nhiều lý do )",
        "chooseReasonLeave": "Chọn lý do xin nghỉ áp dụng",
        "isAccumulationMonthly": "Cho phép cộng dồn phép từng tháng",
        "isAccumulationMonthlyDetail": "Tùy chọn cho phép cộng dồn số ngày phép chưa sử dụng của tháng trước sang tháng sau",
    },
    "messageLeaveSetting": {
        "delete": "Xóa cài đặt nghỉ phép thành công!",
        "add": "Thêm cài đặt nghỉ phép thành công!",
        "update": "Cập nhật cài đặt nghỉ phép thành công!",
        "accumulate" : "Phép còn thừa của tháng trước sẽ được cộng dồn sang tháng sau",
        "deplete" : "Phép còn thừa của tháng trước sẽ được không cộng dồn sang tháng sau",
        "annualLeaveAccumulation" : "Toàn bộ số phép nghỉ của năm (hoặc phép tương ứng với số tháng còn lại) sẽ được cộng vào tháng đầu tiên áp dụng",
        "oldEmployeeLeaveGrant": "Nhân viên cũ: 1 năm được 12 phép. Thì sang năm mới hệ thống sẽ cấp luôn 12 phép cho nhân viên đó",
        "newEmployeeLeaveGrant": "Nhân viên mới: Được công ty tính phép từ tháng 7. Ứng với 6 tháng cuối năm sẽ có 6 phép => Thì hệ thống sẽ cấp luôn 6 phép đó vào tháng 7",
        "recalculateLeaveMidMonth": "Giữa tháng 5 công ty tạo 1 loại phép nghỉ với lựa chọn này => hệ thống sẽ tính toán số phép còn lại của mỗi người và cấp lại toàn bộ phép còn lại của mọi người vào đầu tháng đó",
        "example" : "Ví dụ"




    },
    "leaveSetting": {
        "day": "ngày",
        "year": "năm",
        "days": "ngày",
        "cu": "Cứ",
        "yearSeniorities": "năm thâm niên hưởng",
        "yearSeniority": "năm thâm niên hưởng",
        "seniorityLeave": "phép",
        "seniorityLeaves": "phép",
        "inYear": "Trong năm",
        "nextYear": "Năm sau",
        "cancel": "Hủy bỏ",
        "add": "Thêm mới",
        "update": "Cập nhật",
        "enable": "Kích hoạt",
        "disable": "Vô hiệu hóa"
    },
    "dayStartContractType": {
        "contractFirst": "Ngày của hợp đồng đầu tiên được tính phép",
        "dayEntryOfPersonel": "Ngày vào của nhân sự",
        "officialEntryDate": "Ngày vào chính thức của nhân sự",
        "contract1Year": "Ngày của hợp đồng 1 năm",
        "contractProbation": "Ngày của hợp đồng thử việc",
        "apprenticeshipContract": "Ngày của hợp đồng học việc",
        "indefiniteContract": "Ngày của hợp đồng vô thời hạn",
        "dayOf": "Ngày của"
    },
    "placeholderLS": {
        "all": "Tất cả",
        "day": "Ngày",
        "month": "Tháng"
    },
    "btnTrans": {
        "cancel": "Hủy bỏ",
        "ok": "Xác nhận"
    }
}